module.exports = __webpack_public_path__ + "static/img/Pcon1@2x.6e434950.png";